import { Box, makeStyles, Theme, Typography } from "@material-ui/core"
import React, { FC } from "react"
import clsx from "clsx"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"

type OnlyXLeftTagProps = {
    amount?: number
    variant?: "default" | "floating"
    rounded?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
    containerFloating: {
        position: "absolute",
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    tag: {
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
        fontStyle: "italic",
        fontSize: "0.75rem",
        fontFamily: theme.typography.fontFamily,
    },
    paymentTag: {
        background: "black",
        color: "white",
        width: "fit-content",
        borderRadius: "0.25rem",
        padding: "0 0.375rem",
    },
    floatingTag: {
        background: "#000000",
        color: "#FFFFFF",
        fontWeight: 400,
        fontStyle: "italic",
        fontSize: "0.75rem",
        width: "fit-content",
        borderRadius: "0.25rem",
        padding: "0.25rem 0.75rem",
        lineHeight: 1.6,
    },
    rounded: {
        borderRadius: "5.625rem",
        padding: "0 0.75rem",
    },
}))

export const OnlyXLeftTag: FC<OnlyXLeftTagProps> = ({ amount, variant = "default", rounded = false }) => {
    const classes = useStyles()

    if (!amount) return null

    const isFloating = variant === "floating"
    const containerClass = isFloating ? classes.containerFloating : undefined
    const baseTagClass = isFloating ? classes.floatingTag : classes.paymentTag

    return (
        <Box className={containerClass}>
            <Box className={clsx(baseTagClass, { [classes.rounded]: rounded })}>
                <LocalizedStrict id="offer-tag-limited-on-sale" vars={{ amount: amount }}>
                    <Typography variant="caption">`Only ${amount} left`</Typography>
                </LocalizedStrict>
            </Box>
        </Box>
    );
};
